// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-59baf6f9] .formulate-input[data-type='range'] {

        margin-top: 1rem
}
[data-v-59baf6f9] .formulate-input-element--range {

        border-width: 0px;

        border-style: none
}
[data-v-59baf6f9] .formulate-input-element--range input {

        height: 0.5rem;

        width: 100%;

        -webkit-appearance: none;

           -moz-appearance: none;

                appearance: none;

        border-radius: 2em;

        padding: 0 !important;

        background: var(--slider-background)
}
[data-v-59baf6f9] .formulate-input-element--range input::-webkit-slider-thumb {

        height: 1.25rem;

        width: 1.25rem;

        -webkit-appearance: none;

                appearance: none;

        border-radius: 100%;

        --tw-bg-opacity: 1;

        background-color: rgb(16 33 62 / var(--tw-bg-opacity))
}
[data-v-59baf6f9] .formulate-input-element-range-value {

        --tw-bg-opacity: 1;

        background-color: rgb(16 33 62 / var(--tw-bg-opacity))
}
[data-v-59baf6f9] .formulate-input-tip {

        position: absolute;

        width: -moz-fit-content;

        width: fit-content;

        --tw-translate-x: -33.333333%;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

        font-family: Roboto;

        line-height: 1.5;

        font-size: 0.875rem;

        font-weight: 400
}
[data-v-59baf6f9] .formulate-input-tip-wrapper {

        position: relative;

        width: 100%;

        padding-top: 0.5rem;

        padding-bottom: 0.5rem
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/inputs/slider/SliderInput.vue"],"names":[],"mappings":";AA6FA;;QAAA;AAAA;AAIA;;QAAA,iBAAA;;QAAA;AAAA;AAGA;;QAAA,cAAA;;QAAA,WAAA;;QAAA,wBAAA;;WAAA,qBAAA;;gBAAA,gBAAA;;QAAA,kBAAA;;QAAA,qBAAA;;QAEA;AAFA;AAKA;;QAAA,eAAA;;QAAA,cAAA;;QAAA,wBAAA;;gBAAA,gBAAA;;QAAA,mBAAA;;QAAA,kBAAA;;QAAA;AAAA;AAKA;;QAAA,kBAAA;;QAAA;AAAA;AAIA;;QAAA,kBAAA;;QAAA,uBAAA;;QAAA,kBAAA;;QAAA,6BAAA;;QAAA,+LAAA;;QAAA,mBAAA;;QAAA,gBAAA;;QAAA,mBAAA;;QAAA;AAAA;AAGA;;QAAA,kBAAA;;QAAA,WAAA;;QAAA,mBAAA;;QAAA;AAAA","sourcesContent":["<template>\n  <div>\n    <CurrencyInput v-if=\"isCurrency\" v-model=\"model\" v-bind=\"{...$attrs, ...props}\" />\n    <div>\n      <FormulateInput ref=\"slider\" :id=\"name\" type=\"range\" v-model=\"model\" :min=\"min\" :max=\"max\" />\n      <div v-if=\"props.optimalTips && visibleTips\" class=\"formulate-input-tip-wrapper\">\n        <p class=\"formulate-input-tip\" :style=\"tipStyle\">{{ isEnough ? 'óptimo' : 'no es suficiente' }}</p>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport CurrencyInput from '@/lego/components/inputs/numeric/CurrencyInput.vue';\nimport { computed, onMounted, ref, watchEffect } from '@vue/composition-api';\nimport { defineCssVars } from '@/lego/utils/style/vars';\n\nexport default {\n  components: { CurrencyInput },\n  props: {\n    type: {\n      type: String,\n      default: 'currency',\n    },\n    value: {\n      type: String,\n    },\n    min: {\n      type: Number,\n      default: 0,\n    },\n    max: {\n      type: Number,\n      default: 20000000,\n    },\n    optimalTips: {\n      type: Boolean,\n      default: false,\n    },\n    optimalVal: {\n      type: Number,\n      required: false,\n    },\n  },\n  setup(props, { root }) {\n    const slider = ref(null);\n    const model = ref(0);\n    const visibleTips = computed(() => props.optimalTips && !!model.value && parseInt(model.value) > 0);\n    const name = computed(() => 'slider-' + root.$attrs.name);\n    const isCurrency = computed(() => props.type === 'currency');\n    const isEnough = computed(() => model.value >= props.optimalVal);\n\n    const getSliderColor = function() {\n      return isEnough.value ? '#0CC175' : '#D80003';\n    };\n    const sliderColor = computed(() => (props.optimalTips ? getSliderColor() : '#6B7280'));\n    const sliderPercent = computed(() => ((model.value - props.min) / (props.max - props.min)) * 100);\n    const sliderStyle = computed(() => `linear-gradient(to right, ${sliderColor.value} 0%, ${sliderColor.value} ${sliderPercent.value}%, #D1D5DB ${sliderPercent.value}%, #D1D5DB 100%)`);\n    const tipStyle = computed(() => ({\n      color: sliderColor.value,\n      left: `${sliderPercent.value}%`,\n    }));\n\n    onMounted(() => {\n      watchEffect(() =>\n        defineCssVars(\n          {\n            '--slider-background': sliderStyle.value,\n          },\n          slider.value.$el\n        )\n      );\n      model.value = props.value ?? 0;\n    });\n\n    return {\n      slider,\n      visibleTips,\n      model,\n      props,\n      isCurrency,\n      isEnough,\n      name,\n      sliderStyle,\n      tipStyle,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n/deep/ .formulate-input {\n  &[data-type='range'] {\n    @apply mt-xxxs;\n  }\n  &-element {\n    &--range {\n      @apply border-none;\n\n      input {\n        @apply w-full !p-0 appearance-none h-nano rounded-pill;\n\n        background: var(--slider-background);\n\n        &::-webkit-slider-thumb {\n          @apply appearance-none rounded-circular bg-brand-secondary-dark w-[1.25rem] h-[1.25rem];\n        }\n      }\n    }\n    &-range-value {\n      @apply bg-brand-secondary-dark;\n    }\n  }\n  &-tip {\n    @apply w-fit absolute style-overline -translate-x-1/3;\n\n    &-wrapper {\n      @apply w-full relative py-nano;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
